import React from "react";
import Text from "components/Text";

import { sizes } from "assets/constants";
import { ViewStyle } from "react-native";

type InputLabelT = {
  label?: string;
  desc?: string;
  removedSpace?: boolean;
  style?: ViewStyle;
  textProps?: TextT;
};

const InputLabel: React.FC<InputLabelT> = ({
  label = "",
  desc = "",
  removedSpace = false,
  style,
  textProps,
}) => {
  return (
    <Text
      style={{
        marginRight: sizes.space / 2,
        marginBottom: removedSpace ? 0 : sizes.space / 2,
        ...style,
      }}
      weight="bold"
      {...textProps}
    >
      {label}
      {desc && <Text>{desc}</Text>}
    </Text>
  );
};

export default InputLabel;
